import { render, staticRenderFns } from "./SelectCard.vue?vue&type=template&id=9a696072&"
import script from "./SelectCard.vue?vue&type=script&lang=ts&"
export * from "./SelectCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports